export default __webpack_public_path__ + "static/collection-7ca7d330d46ad700e2b7b43c7941e285.png";